import { Address } from '../../model/dto/address';

const COMPARED_FIELDS: (keyof Address)[] = [
  'company_name',
  'first_name',
  'last_name',
  'address1',
  'address2',
  'city',
  'postal_code',
  'region',
  'region_code',
  'country',
  'country_code',
  'phone',
];

const normalize = (value?: string | null): string =>
  (value ?? '').trim().toLowerCase();

export const areAddressesEqual = (
  first?: Address | null,
  second?: Address | null
): boolean => {
  if (!first || !second) {
    return false;
  }

  return COMPARED_FIELDS.every(
    (field) => normalize(first[field]) === normalize(second[field])
  );
};

export const getAddressFullName = (address?: Address | null): string =>
  [address?.first_name, address?.last_name]
    .map((name) => name?.trim())
    .filter(Boolean)
    .join(' ');
